export enum LoyaltyProgramRewardType {
  None = 0,
  Promotion = 1,
  WalletCredit = 2,
}
